import React, {useState} from 'react';
import {Modal} from "react-bootstrap";
import {useTranslation, withTranslation} from "react-i18next";
import {connect, DispatchProp} from "react-redux";
import Languages from "../Common/Languages";
import {RootState} from "../../../reducers";
import {getLocation} from "../../services/Session/reducer";
import {useSessionService} from "../../services/Session/sessionService";
import {getStoreConfig} from "../../services/Store/reducer";
import ErrorFormView from "../Common/ErrorFormView";
import ErrorFormHelper from "../../utils/ErrorFormHelper";
import ErrorFormAlertView from "../Common/ErrorFormAlertView";
import QRCodeScannerComponent from "../Common/QRCodeScannerComponent";
import {ApiError} from "../../services/Api/types";
import LoadingContainer from "../Common/LoadingContainer";
import StoreUtils from "../../services/Store/StoreUtils";
import {SessionState} from "../../services/Session/types";
import IframeWidget from "../../utils/IframeWidget";


interface OwnProps {
    tableName: string,
    onSave: () => void,
    onHide: () => void,
    show: boolean,
    showLanguages?: boolean
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

function ChangeTableNumberModal(props: Props) {
    const [tableName, setTableName] = useState(props.tableName ? props.tableName : "");
    const [errors, setErrors] = useState<ApiError[]>([]);
    const [loading, setLoading] = useState(false);
    const {t} = useTranslation();
    const sessionService = useSessionService();

    const onShow = () => {
        setTableName(props.tableName ? props.tableName : "")
        setErrors([]);
    }
    let possibleEditNumber = props.config?.ordering.number_editable;

    const saveTableNumber = async (tableNumber: string) => {
        setLoading(true);
        // if (!possibleEditNumber) {
        //     props.onSave();
        //     return;
        // }

        let sessionData = {
            ...props.session_state,
            order_type: "DINE_IN",
            table_number: tableNumber
        } as SessionState
        try {
            await sessionService.update(sessionData);
            props.onSave();
            setLoading(false);
            IframeWidget.onHide(props.onHide)
        } catch (err: any) {
            setErrors(err.errors);
            setLoading(false);
        }
    }
    const onScan = (data: string) => {
        if (!data) {
            setErrors([{
                message: t("constraints.internal.wrong_qrcode_link")
            }])
            return;
        }
        if (data.startsWith("http://") || data.startsWith("https://")) {
            try {
                const url = new URL(data);
                const pathSegments = url.pathname.split('/').filter(Boolean);
                const orderType = pathSegments[pathSegments.length - 1];
                if (!StoreUtils.isSameDomain(data, props.config?.domain) || !orderType || orderType !== "DINE_IN") {
                    setErrors([{
                        message: t("constraints.internal.wrong_qrcode_link")
                    }])
                    return;
                }
                const numberParam = url.searchParams.get("number");
                if (numberParam !== null) {
                    saveTableNumber(numberParam);
                } else {
                    setErrors([{
                        message: t("constraints.internal.wrong_qrcode_link")
                    }])
                }
            } catch (error) {
                setErrors([{
                    message: t("constraints.internal.wrong_qrcode_link")
                }])
            }
        } else {
            setErrors([{
                message: t("constraints.internal.wrong_qrcode_link")
            }])
        }
    }

    return (
        <React.Fragment>
            <Modal dialogClassName="modal-full" show={props.show} onHide={() => IframeWidget.onHide(props.onHide)}
                   onShow={() => IframeWidget.onShow(onShow)}>
                <div className="">
                    <Modal.Header>
                        <Modal.Title>
                            {t("common.action.choose_table")}
                        </Modal.Title>
                        <button onClick={() => IframeWidget.onHide(props.onHide)} className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"></button>
                    </Modal.Header>
                </div>
                <Modal.Body>
                    <div>
                        {props.showLanguages && (
                            <Languages size={"xl"}/>
                        )}

                        {!props.config?.ordering.scanner_disabled && (
                            <>
                                {errors.length > 0 ? (
                                    <>
                                        <ErrorFormAlertView errors={errors}/>
                                        <button className={"btn btn-default btn-lg w-100 mb-4"}
                                                onClick={() => setErrors([])}>
                                            {t("common.action.scan_again")}
                                        </button>
                                    </>
                                ) : (
                                    <>
                                        {loading ? (
                                            <div>
                                                <LoadingContainer> {t("common.word.processing_in_progress")}</LoadingContainer>
                                            </div>
                                        ) : (
                                            <>
                                                <p className={"text-center mb-1"}>
                                                    {t("modules.cart.field.scan_table_qr_code.title")}
                                                </p>
                                                <QRCodeScannerComponent onScan={onScan}/>
                                            </>
                                        )}
                                    </>
                                )}
                            </>
                        )}


                        {(!possibleEditNumber && !tableName) ? (
                            <>
                                {props.config?.ordering.scanner_disabled && (
                                    <div className={"alert alert-danger"}>
                                        {t("constraints.internal.number_table_not_null")}
                                    </div>
                                )}
                            </>
                        ) : (
                            <>
                                <div className="form-group">
                                    <input type="text" disabled={!possibleEditNumber} value={tableName}
                                           onChange={e => setTableName(e.target.value)}
                                           className={"form-control" + ErrorFormHelper(errors, "number")}
                                           id="table_name"
                                           placeholder={t("modules.table_number_modal.field.table_number.title") + "*"}/>
                                    <label
                                        htmlFor="street">{t("modules.table_number_modal.field.table_number.title")}</label>
                                    <ErrorFormView errors={errors} field="number"/>
                                </div>
                            </>
                        )}
                    </div>
                    {possibleEditNumber && (
                        <button
                            className={"btn-spinner btn-block btn-primary btn btn-submit" + (loading ? ' loading' : '')}
                            onClick={() => {
                                saveTableNumber(tableName)
                            }}>
                            <span className="left spinner-border spinner-border-sm"></span>
                            {t("common.action.save")}
                        </button>
                    )}
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}


const mapStateToProps = (state: RootState) => ({
    config: getStoreConfig(state.config),
    session_state: getLocation(state.session)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(ChangeTableNumberModal));